import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const SeparatorLinksRecipesContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .title {
    ${Font.sansBold};
    color: #000;
    font-size: 25px;
    display: flex;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
    &::first-letter {
      text-transform: capitalize;
    }
    a {
      all: unset;
      cursor: pointer;
    }
  }
  .containerAutoFlex {
    display: flex;
  }
  .links-recipes {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    /*overflow-x: scroll;*/
    flex-direction: row;
    padding: 16px 0px 22px;
    border-top: 1px solid ${Color.mainColor};
    border-bottom: 1px solid ${Color.greySeparator};
    margin: 25px 0 0;
    ${breakpoints.tablet} {
      padding: 0;
    }
    ${breakpoints.phone} {
      padding: 0px 3px;
    }
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        border-top: 1px solid ${ColorDark.mainColor};
        border-bottom: 1px solid ${ColorDark.greySeparator};
      }
    }
  }
  button {
    border: none;
    background: none;
    cursor: pointer;
  }
  .links-recipes-title {
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid ${Color.grey777};
    gap: 12px;
    padding: 2px 0px;
    padding-right: 15px;
    text-wrap: nowrap;
    .links-recipes-title-text {
      ${Font.sansRegular}
      font-size: 14px;
      line-height: 18px;
      color: ${Color.grey};
      padding-bottom: 2px;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
  }
  .links-recipes-title > div svg {
    color: #555 !important;
  }
  .links-recipes-items {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 22px;
    ${breakpoints.tablet} {
      width: 100%;
      padding: 15px 0;
      justify-content: flex-start;
    }
    ${breakpoints.phone} {
      width: 100%;
      padding: 15px 0;
      justify-content: flex-start;
      gap: 15px;
    }
    .title {
      ${Font.clarinVarSub2ExtraBold}
      font-size: 36px;
      color: ${Color.mainColor};
      ${breakpoints.phone} {
        font-size: 28px;
        padding-bottom: 2px;
      }
    }
    .links-separator {
      border-top: 1px solid ${Color.greySeparator};
      width: 100%;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          border-top: 1px solid ${ColorDark.greySeparator};
        }
      }
    }
    .links-container {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 15px;
      ${breakpoints.phone} {
        overflow-x: scroll;
        width: 100%;
      }
      .links-recipes-link {
        ${Font.sansRegular}
        font-size: 14px;
        line-height: 18px;
        color: ${Color.grey};
        ${breakpoints.tablet} {
          text-wrap: nowrap;
        }
        ${breakpoints.phone} {
          text-wrap: nowrap;
        }
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            color: ${ColorDark.textLight};
          }
        }
      }
      .links-recipes-dot {
        width: 2px;
        height: 2px;
        aspect-ratio: 1;
        border-radius: 50%;
        background-color: ${Color.grey};
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            background-color: ${ColorDark.textLight};
          }
        }
      }
      .links-recipes-dot:last-of-type {
        display: none;
      }
    }
  }
  .is-not-title-header {
    border-top: none;
    padding-bottom: 35px;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        border-top: none;
      }
    }
    ${breakpoints.tablet} {
      padding: 20px;
    }
    ${breakpoints.phone} {
      padding-bottom: 10px;
    }
    .links-recipes-items .title {
      ${Font.sansBold}
      color: rgb(0, 0, 0);
      font-size: 25px;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
  }
  .food-card-container {
    top: 374px;
    left: 215px;
    width: 280px;
    height: 331px;
    position: absolute;
  }
`;
